<mat-toolbar class="header-toolbar">
  <mat-toolbar-row class="tw-flex tw-justify-between">
    <div class="header-toolbar_left-side tw-flex">
      <button class="menu-btn tw-self-center" mat-icon-button (click)="sideNavDrawer.getValue().toggle()">
        <ui-svg-icon
          [name]="sideNavDrawer.getValue()?.opened ? iconNames.Close : iconNames.ListViewMobile"
        ></ui-svg-icon>
      </button>

      <projection-slot [name]="projectorName.PageData"></projection-slot>
    </div>
    <div class="tw-flex">
      <projection-slot [name]="projectorName.HubContextSelection"></projection-slot>

      <ui-svg-icon [name]="iconNames.Globe" class="menu-globe"></ui-svg-icon>
      <mat-form-field class="language-select tw-self-center">
        <mat-select [formControl]="languageControl">
          <mat-select-trigger>
            {{ languageControl.value | uppercase }}
          </mat-select-trigger>

          <mat-option *ngFor="let language of languageList$ | async" [value]="language">
            <div>
              <span>{{ 'common.language.' + language | lowercase | translate }} - {{ language | uppercase }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="userData; else loginButtonTemplate" class="user-menu-btn" [matMenuTriggerFor]="userMenu">
        <div class="user-email">
          {{ userData.fullName }}
        </div>

        <ui-svg-icon [name]="iconNames.MyBrandFrame"></ui-svg-icon>
      </div>
      <div *show="permissionConfig.support_info.self" class="user-menu-btn" [matMenuTriggerFor]="supportMenu">
        <div class="support">{{ 'common.field.support' | translate }}</div>
        <ui-svg-icon [name]="iconNames.UserDesktop"></ui-svg-icon>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<ng-template #loginButtonTemplate>
  <button mat-stroked-button routerLink="/">
    {{ 'common.field.login' | translate }}
  </button>
</ng-template>

<mat-menu #userMenu="matMenu">
  <button mat-menu-item routerLink="administration/profile">
    {{ 'administration.profile.title' | translate }}
  </button>
  <button *ngIf="isSkidUser" mat-menu-item (click)="openSkidLogIn()">
    <span class="tw-flex tw-justify-between tw-w-full">
      <span>{{ 'common.field.singlekeyID' | translate }}</span>
      <img class="skidkey_img tw-self-center" src="/assets/core/images/skid_key.svg" alt="Image" />
    </span>
  </button>

  <button class="menu-item__logout" mat-menu-item (click)="logout.emit()">
    <span class="tw-flex tw-justify-between tw-w-full">
      <span>{{ 'common.field.logout' | translate }}</span>
      <ui-svg-icon [name]="iconNames.Exit" class="tw-self-center tw-text-light-grey-900"></ui-svg-icon>
    </span>
  </button>
</mat-menu>

<mat-menu #supportMenu="matMenu">
  <a *ngIf="!isSkidUser" mat-menu-item href="{{ raiseTicketUrl }}" target="_blank">
    <b class="tw-flex tw-items-center">
      <ui-svg-icon [name]="iconNames.WrenchWarning" class="menu-globe tw-text-light-grey-900"></ui-svg-icon>
      <span class="tw-ml-1">{{ 'common.field.raiseIssueTicket' | translate }}</span>
    </b>
  </a>
  <a *ngIf="isSkidUser" mat-menu-item href="mailto: {{ contactEmail }}">
    <b class="tw-flex tw-items-center">
      <ui-svg-icon [name]="iconNames.Mail" class="menu-globe tw-text-light-grey-900"></ui-svg-icon>
      <span class="tw-ml-1">{{ contactEmail }}</span>
    </b>
  </a>
  <a mat-menu-item href="tel:{{ contactPhoneNumber }}" class="tw-flex tw-items-center">
    <ui-svg-icon [name]="iconNames.Smartphone" class="menu-globe tw-text-light-grey-900"></ui-svg-icon>
    <span class="tw-ml-1">{{ contactPhoneNumber }}</span>
  </a>

  <a mat-menu-item href="{{ userGuide }}" target="_blank" class="tw-flex tw-items-center">
    <ui-svg-icon [name]="iconNames.Document" class="menu-globe tw-text-light-grey-900"></ui-svg-icon>
    <span class="tw-ml-1">{{ 'common.field.userGuide' | translate }}</span>
  </a>

  <div class="contact-timings" style="font-size: 12px !important">{{ 'common.field.phone' | translate }}:</div>

  <div class="contact-timings"><b>En:</b> 04:00 - 24:00 CET Mon - Fri</div>
  <div class="contact-timings"><b>De:</b> 08:00 - 16:00 CET Mon - Fri</div>

  <div *ngIf="!isSkidUser" class="contact-timings" style="font-size: 12px !important">
    {{ 'common.field.tickets' | translate }}:
  </div>

  <div *ngIf="isSkidUser" class="contact-timings" style="font-size: 12px !important">
    {{ 'common.field.email' | translate }}:
  </div>

  <div class="contact-timings"><b>En:</b> 04:00 - 24:00 CET Mon - Fri</div>
  <div class="contact-timings"><b>De:</b> 08:00 - 16:00 CET Mon - Fri</div>
</mat-menu>
